import { useQuery } from '@apollo/client/react';
import { BookingReview, ReviewConfirmation } from '@drycut/booking-components';
import {
  type BasicReviewFragment,
  type CompleteBookingFragment,
  GetBookingDocument,
  type Maybe,
} from '@drycut/graphql';
import { Loader } from '@drycut/ui-components';
import { useNavigate, useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function NewBookingReview() {
  useDocumentTitle('DRYCUT - Booking Review');

  const navigate = useNavigate();
  const { bookingUid } = useParams() as { bookingUid: string };
  const { data, loading } = useQuery(GetBookingDocument, { variables: { uid: bookingUid } });

  const booking: Maybe<CompleteBookingFragment> = data?.booking || null;
  const review: Maybe<BasicReviewFragment> = booking?.review || null;

  if (loading) {
    return <Loader />;
  }

  if (!booking) {
    navigate('/not-found');
    return null;
  }

  if (review) {
    return <ReviewConfirmation customer={booking.customer} />;
  }

  return <BookingReview booking={booking} />;
}
